import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Color, Orientation, Icons } from '@lsq-frontend/common-ui';

@Component({
    selector: 'admin-buyer-configuration-paid-fees-visibility',
    template: `
        <buyer-configuration-section
            [hasClickedSave]="hasClickedSave"
            sectionTitle="Buyer Paid Fee Columns"
            sectionFormControlName="buyerPaidEarlyPaymentFeeVisibilityEnabled"
            [sectionFormGroup]="buyerPaidEarlyPaymentFeesVisibilityFormGroup"
        >
            <form
                [formGroup]="buyerPaidEarlyPaymentFeesVisibilityFormGroup"
                [style.padding]="'2rem 3rem'"
            >
                <div class="row">
                    <div class="col-12" [style.marginBottom]="'1.8rem'">
                        <div class="text-bold">Buyer Paid Early Payment Fees Visible</div>
                        <p>
                            This setting enables the buyer experience and exports to display columns
                            related to Buyer Paid Fees Percentage and Transactions. Please note that
                            depending on what reports the buyer has scripts for, data exchange may
                            be impacted by the new columns.
                        </p>
                    </div>
                    <div class="col-12" [style.marginBottom]="'1rem'">
                        <lsq-switch
                            containerClass="flex-left-to-right"
                            [labelOrientation]="orientation.Right"
                            [labelTemplateRef]="buyerPaidFeesVisibilityLabelTemplate"
                            labelClass="text-bold"
                            [id]="'buyerPaidEarlyPaymentFeeVisibilityActive'"
                            [name]="'buyerPaidEarlyPaymentFeeVisibilityActive'"
                            [formControlName]="'buyerPaidEarlyPaymentFeeVisibilityActive'"
                            [group]="buyerPaidEarlyPaymentFeesVisibilityFormGroup"
                        ></lsq-switch>
                        <ng-template #buyerPaidFeesVisibilityLabelTemplate>
                            <lsq-label
                                [label]="'Enable Buyer Paid Fee Columns'"
                                [subLabel]="'The columns will be visible in the UI and exports.'"
                            ></lsq-label>
                        </ng-template>
                    </div>
                </div>
            </form>
        </buyer-configuration-section>
    `
})
export class AdminBuyerConfigurationPaidFeesVisibilityComponent {
    @Input() public buyerPaidEarlyPaymentFeesVisibilityFormGroup: FormGroup;
    @Input() public hasClickedSave: boolean;

    public readonly icons = Icons;
    public readonly color = Color;
    public readonly orientation = Orientation;
}
